import { render, staticRenderFns } from "./CloseAppFooter.vue?vue&type=template&id=00a2d2b0"
import script from "./CloseAppFooter.vue?vue&type=script&lang=js"
export * from "./CloseAppFooter.vue?vue&type=script&lang=js"
import style0 from "./CloseAppFooter.vue?vue&type=style&index=0&id=00a2d2b0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports